import type { IconSvgObject } from './types';

const RightToLeftListDashIcon: IconSvgObject = [
  ["path", { d: "M3 5L15 5", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M19 5L21 5", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M3 12L15 12", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M19 12L21 12", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M3 19L15 19", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "4" }],
  ["path", { d: "M19 19L21 19", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "5" }]
];

export default RightToLeftListDashIcon;
